import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";

const AuthCallback = () => {
    const { isAuthenticated, user } = useAuth0();
    const navigate = useNavigate();
    const location = useLocation()
    const { t } = useLanguage();

    useEffect(() => {
        if (isAuthenticated) {
            const redirectAfterLogin = localStorage.getItem("redirectAfterLogin");
            console.log('redirectAfterLogin',redirectAfterLogin);
            navigate(redirectAfterLogin || "/")
        }

    }, [isAuthenticated, navigate]);

    return <p>{t('common.redirecting')}</p>;
};

export default AuthCallback;